import { RefObject, useCallback } from 'react';
import { REACT_APP_BLOCKSUITE_URL } from '../../../../global/environment';
import { DropdownItem } from '../../../../component/dropdown';

export default function ExportSubMenu({ editorIframe }: { editorIframe: RefObject<HTMLIFrameElement> }) {
  // for export in to pdf
  const exportToPdf = useCallback(() => {
    editorIframe.current?.contentWindow?.postMessage({ type: 'export', payload: 'pdf' }, `${REACT_APP_BLOCKSUITE_URL}`);
  }, [editorIframe]);

  // for export in to HTML
  const exportToHtml = useCallback(() => {
    editorIframe.current?.contentWindow?.postMessage(
      { type: 'export', payload: 'html' },
      `${REACT_APP_BLOCKSUITE_URL}`
    );
  }, [editorIframe]);

  // for export in to markDown
  const exportToMarkdown = useCallback(() => {
    editorIframe.current?.contentWindow?.postMessage(
      { type: 'export', payload: 'markdown' },
      `${REACT_APP_BLOCKSUITE_URL}`
    );
  }, [editorIframe]);

  // for export in to PNG
  const exportToPng = useCallback(() => {
    editorIframe.current?.contentWindow?.postMessage({ type: 'export', payload: 'png' }, `${REACT_APP_BLOCKSUITE_URL}`);
  }, [editorIframe]);

  return (
    <>
      <DropdownItem label='Export to PDF' onClick={exportToPdf} />
      <DropdownItem label='Export to HTML' onClick={exportToHtml} />
      <DropdownItem label='Export to PNG' onClick={exportToPng} />
      <DropdownItem label='Export to Markdown' onClick={exportToMarkdown} />
    </>
  );
}
